export default [
    {
      path: '/languages',
      name: 'languages-read',
      component: () => import('@/views/languages/languages-list/LanguagesList.vue'),
      meta: {
        resource: 'Languages',
        action: 'read',
      },
    },
    
  ]
  